import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum LoadingActions {
  NAME = '@LOADING',
  SET_LOADING = '@LOADING/setLoading'
}

export enum RequestType {
  LUGGAGE = 'LUGGAGE',
  LOAD_MORE_RESULTS = 'LOAD_MORE_RESULTS',
  BASKET = 'BASKET'
}

interface SetLoadingPayload {
  loading: boolean;
  request: RequestType;
}

export const INITIAL_LOADING_STATE: Record<string, boolean> = {
  [RequestType.LUGGAGE]: false,
  [RequestType.LOAD_MORE_RESULTS]: false
};

const loadingSlice = createSlice({
  name: LoadingActions.NAME,
  initialState: INITIAL_LOADING_STATE,
  reducers: {
    setLoading: (state, action: PayloadAction<SetLoadingPayload>) => {
      const { loading, request } = action.payload;
      state[request] = loading;
    }
  }
});

export const { setLoading } = loadingSlice.actions;

export const loadingReducer = loadingSlice.reducer;
